/** Access by app — mirrors AppAccess::Level and the admin presenters. */

export type AccessLevel = "no_access" | "read_only" | "edit"

/** app key → level, e.g. { automations: "edit" }. The shared `app_access` prop. */
export type AppAccessMap = Record<string, AccessLevel>

export type LevelOption = { value: AccessLevel; label: string }

export const ACCESS_LEVEL_LABELS: Record<AccessLevel, string> = {
  no_access: "No Access",
  read_only: "Read only",
  edit: "Edit",
}

/** How strongly a level is shown: Edit stands out, No Access recedes. */
export const ACCESS_LEVEL_TONES = {
  edit: "accent",
  read_only: "neutral",
  no_access: "muted",
} as const

/** One app, as the registry declares it. */
export type AccessApp = {
  key: string
  label: string
  description: string | null
  iupat_only: boolean
}

export type AccessGroupRow = {
  id: number | null
  name: string
  description: string | null
  joined_at_first_sign_in: boolean
  /** Set only on the two groups the app ships with. */
  system_key: string | null
  levels: Record<string, AccessLevel>
  member_count: number
}

export type AccessGroupMember = {
  user_id: number
  name: string
  email: string | null
  organization: string | null
  admin: boolean
  placeholder: boolean
  /** Blank when nobody chose it: the launch backfill, or first sign-in. */
  added_by: string | null
  added_at: string
}

/** One app on a person's admin page. */
export type UserAppAccess = {
  key: string
  label: string
  iupat_only: boolean
  level: AccessLevel
  source: "admin" | "override" | "group" | "none" | "iupat_only"
  /** "Edit — from DC Staff" */
  source_label: string
  override: AccessLevel | null
  override_set_by: string | null
  override_set_at: string | null
}

export type UserAccessGroup = {
  id: number
  name: string
  description: string | null
  levels: Record<string, AccessLevel>
  member: boolean
}
